import React from "react";
import homepageLogo from "../assets/homepage.svg";

export const Logo: React.FC = () => (
  <img
    src={homepageLogo}
    alt="Expedient Logo"
    style={{
      width: 32,
      height: 32,
      borderRadius: 6,
      objectFit: "contain",
      background: "transparent",
      display: "block",
    }}
  />
);
